import * as R from 'ramda';
import Api from '../../../common/services/api';
import { LEARNING_CREATE_FROM_OUTLINE } from './index';

export default (settings, outline) => async (dispatch, getState) => {
  const { organisation: { selected } } = getState();

  // Transform settings to match API field naming requirements
  const transformedSettings = {
    topic: settings.topic,
    fileId: settings.fileId,
    industry: settings.industry,
    length: settings.length,
    includeQuiz: settings.includeQuiz,
    language: settings.language,
    toneOfVoice: settings.toneOfVoice,
    learningGoal: settings.learningGoal,
    courseType: settings.courseType
  };

  const payload = {
    settings: transformedSettings,
    outline
  };

  const { data: course } = await Api.post(
    `/v2/organisations/${selected.id}/courses/create_from_outline`,
    payload
  );

  return dispatch({
    type: LEARNING_CREATE_FROM_OUTLINE,
    item: course,
  });
};
